// https://github.com/ljharb/proposal-is-error
var $export = require('./_export');
var cof = require('./_cof');

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});



// WEBPACK FOOTER //
// ./node_modules/core-js/modules/es7.error.is-error.js